export default {
  'label/delete_my_account/title': 'Deletar minha conta',
  'label/delete_my_account/text_line_1': 'Ao excluir sua conta, você perde o acesso ao Doutore. Essa ação não pode ser desfeita.',
  'label/delete_my_account/text_line_2': 'Os prontuários dos seus pacientes têm guarda obrigatória por lei: eles não são apagados junto com a conta e ficam guardados com segurança pelo prazo que a lei e o seu conselho profissional exigem. Se quiser uma cópia, faça antes o Backup Manual, em Suporte Técnico.',
  'label/delete_my_account/text_line_3': 'Por segurança, nossa equipe entra em contato para confirmar a exclusão.',
  'button/delete_my_account': 'Deletar minha conta',
  'button/deleting_my_account': 'Deletando conta...',
  'toast/request_sent': 'Pedido de exclusão enviado. Nossa equipe vai entrar em contato.',
};
